export const products = [
    {
        id: 1,
        img: "https://images.pexels.com/photos/11885785/pexels-photo-11885785.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://insta-clone-1-hazel.vercel.app/",
    },
     
    {
        id: 2,
        img: "https://images.pexels.com/photos/11885401/pexels-photo-11885401.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        link: "https://metaverse-challenge-neon-three.vercel.app/",
    },

    {
        id: 3,
        img: "https://images.pexels.com/photos/11885808/pexels-photo-11885808.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://netflix-clone-6bc4d.web.app/",
    },

    {
        id: 4,
        img: "https://images.pexels.com/photos/11884979/pexels-photo-11884979.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        link: "https://nft-drop-six-indol.vercel.app/nft/noman-apes/",
    },

    {
        id: 5,
        img: "https://images.pexels.com/photos/11885800/pexels-photo-11885800.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        link: "https://portfolio-project-51694.web.app/",
    },

]; 